import { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { authApi } from "@/lib/auth";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const match = location.hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/admin", { replace: true });
      return;
    }
    authApi.exchange(match[1])
      .then((user) => {
        window.history.replaceState(null, "", "/admin/dashboard");
        navigate("/admin/dashboard", { state: { user }, replace: true });
      })
      .catch((err) => {
        const detail = err?.response?.data?.detail;
        setError(typeof detail === "string" ? detail : "Sign-in failed. Please try again.");
      });
  }, [location.hash, navigate]);

  return (
    <main className="min-h-screen flex items-center justify-center bg-void px-6" data-testid="auth-callback">
      {error ? (
        <div className="text-center max-w-sm">
          <p className="text-red-400 text-sm mb-6" data-testid="auth-callback-error">{error}</p>
          <button
            data-testid="auth-callback-back-btn"
            onClick={() => navigate("/admin", { replace: true })}
            className="text-xs text-[#A7D7A0] hover:text-white transition-colors"
          >
            Back to sign in
          </button>
        </div>
      ) : (
        <p className="font-mono-tech text-xs uppercase tracking-[0.3em] text-white/40">Signing you in…</p>
      )}
    </main>
  );
}
